import {Mensaje} from "./mensaje.model";
import {Persona} from "../persona";

export interface MensajeTableParams {
  mensajes: Mensaje[];
  personas: Persona[];
  sources: MensajeTableRowSource;
  filter?: boolean;
  pagination?: boolean;
}

export interface MensajeTableRowSource {
  rolId: string;
  personaId: string;
}

export interface MensajeTableValue {
  fecha: string;
  autor: string;
  contenido: string;
  mensaje: Mensaje;
}
